// frontend/src/pages/Badges.tsx

import { useBadges } from '../hooks/useBadges';
import { BadgeItem } from '../components/badges/BadgeItem';
import '../styles/badges.css';

export function BadgesPage() {
  const { badges, isLoading, error } = useBadges();
  const earnedCount = badges.filter((b) => b.earned).length;

  return (
    <div className="badges-page">
      <header className="badges-header">
        <h1>Rozetlerim 🏆</h1>
        <p>
          Başarılarını topla ve koleksiyonunu tamamla
          {!isLoading && ` — ${earnedCount}/${badges.length} rozet kazandın`}
        </p>
      </header>

      {isLoading && <div className="courses-loading">Yükleniyor...</div>}
      {error && <div className="courses-error">{error}</div>}

      {!isLoading && !error && (
        <div className="badge-grid">
          {badges.map((badge) => (
            <BadgeItem key={badge.id} badge={badge} />
          ))}
        </div>
      )}
    </div>
  );
}
